import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class UTAttachedFileListItem extends SearchModelBase {
    userId: string = '';
    date: string | null = null;
    fromDate: string | null = null;
    toDate: string | null = null;
    refNo: string = '';
    title: string = '';
    fileName: string = '';
    fileSize: number|null = null;
    fromFileSize: number|null = null;
    toFileSize: number|null = null;
    contents: string = '';
    tbName: string = '';
    tbId: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'User ID', width: 90, dataIndex: 'userId', defaultColumnFocus: true }),
        XCol.Create({ col: 2, text: 'Date', width: 65, dataIndex: 'date', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 3, text: 'Ref. #', width: 100, dataIndex: 'refNo'}),
        XCol.Create({ col: 4, text: 'Title', width: 170, dataIndex: 'title'}),
        XCol.Create({ col: 5, text: 'Attached File Name', width: 170, dataIndex: 'fileName'}),
        XCol.Create({ col: 6, text: 'File Size', width: 80, dataIndex: 'fileSize', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true }),
        XCol.Create({ col: 7, text: 'Contents', width: 800, dataIndex: 'contents'})
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: UTAttachedFileListItem.prototype.tbId, orderByAscending: false };

    public static formatData(data: UTAttachedFileListItem[]) {
        return data.map((d: UTAttachedFileListItem) => ({
          ...d,
        }));
    }
    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        date: {from: 'fromDate', to: 'toDate'},
        fileSize: {from: 'fromFileSize', to: 'toFileSize'},
    }
}
